import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Chrome shared by every guide sheet — section headings, field-kind badges,
 * the colour-legend prefix, and the page-status banner text.
 *
 * Carries no pages: it exists so the shared strings travel through the same
 * per-domain merge as everything else rather than needing a second mechanism.
 */
export const commonGuide: DomainGuide = {
  domain: 'common',
  pages: [],
  copy: { th, en, zh, vi, km, lo, my },
};
